import api, { adminApiPrefix } from './Api';
import {
  DashboardStats,
  dashboardStatsFromResponse,
} from '../interfaces/Dashboard/DashboardStats';

const dashboardAdminApiPrefix = `${adminApiPrefix}/dashboard`;

export const getDashboardStats = async (): Promise<DashboardStats> => {
  const response = await api.get(`${dashboardAdminApiPrefix}/stats`);

  return dashboardStatsFromResponse(response.data);
};
